<template>
  <div class="flex items-center w-full select-none">
    <template v-for="(s, i) in steps" :key="s.key">
      <div class="flex items-center gap-2 shrink-0">
        <div
          class="flex items-center justify-center w-7 h-7 rounded-full border-2 text-sm font-semibold transition-colors"
          :class="nodeClass(i)"
        >
          <Icon
            v-if="i < currentIndex"
            icon="feather:check"
            class="w-4 h-4"
          ></Icon>
          <span v-else>{{ i + 1 }}</span>
        </div>
        <span
          class="text-sm whitespace-nowrap transition-colors"
          :class="
            i === currentIndex
              ? 'font-semibold text-base-content'
              : 'text-base-content/50'
          "
        >
          {{ s.label }}
        </span>
      </div>
      <div
        v-if="i < steps.length - 1"
        class="flex-1 h-0.5 mx-2 rounded transition-colors"
        :class="i < currentIndex ? 'bg-primary' : 'bg-base-300'"
      ></div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Icon } from "@iconify/vue";

const props = defineProps<{ step: string }>();

// Mirrors the `step` values used in App.vue (`load` / `redact` / `review` / `export`).
const steps = [
  { key: "load", label: "Load" },
  { key: "redact", label: "Edit & redact" },
  { key: "review", label: "Review" },
  { key: "export", label: "Export" },
];

const currentIndex = computed(() => {
  const idx = steps.findIndex((s) => s.key === props.step);
  return idx === -1 ? 0 : idx;
});

function nodeClass(i: number) {
  if (i < currentIndex.value) {
    return "bg-primary border-primary text-primary-content";
  }
  if (i === currentIndex.value) {
    return "border-primary text-primary";
  }
  return "border-base-300 text-base-content/40";
}
</script>
